import "./ConfirmDialog.css";

import React, { PureComponent } from "react";
import { Dialog } from "@mui/material";
import { DialogActions } from "@mui/material";
import { DialogContent } from "@mui/material";
import { DialogTitle } from "@mui/material";
import { Button } from "@mui/material";

/**
 * @title String displayed in header
 * @info css style and icon of info
 * @success css style and icon of success
 */
export class ConfirmDialog extends PureComponent {
	componentDidMount() {
		// Translate
		// langStd.setLanguage(Rights.getLanguage());
	}

	handleClickYes = () => {
		this.Close("yes");
	};

	handleClickOk = () => {
		this.Close("ok");
	};

	handleClickNo = () => {
		this.Close("no");
	};

	handleClickCancel = () => {
		this.Close("cancel");
	};

	Close = (reason) => {
		this.props.onClose(reason);
	};

	// Change header color
	getClass() {
		// Success (Green)
		if (this.props.success) return "success";

		// Info (Grey)
		if (this.props.info) return "info";

		// Default is error (Red)
		return "";
	}

	getIcon() {
		// Success (Green Check)
		if (this.props.success) return "check-circle-outline";

		// Info (Grey Exclamation mark)
		if (this.props.info) return "information-outline";

		// Error (Red Exclamation mark)
		if (this.props.error) return "alert-circle-outline";

		// Default
		return null;
	}

	render() {
		let { ok, cancel, yes, no, title, open } = this.props;

		return (
			<Dialog
				id="ConfirmDialog"
				open={open}
				onClose={this.onClose}
				aria-labelledby="form-dialog-title"
				className={`myDialog ${this.getClass()}`}
				onBackdropClick={this.Close}
			>
				<DialogTitle id="form-dialog-title">
					{/* ICON */}
					{this.getIcon() && <i className={`mdi mdi-${this.getIcon()}`} />}

					{/* TITLE */}
					{title}
				</DialogTitle>
				<DialogContent>
					<p>{this.props.children}</p>
					<DialogActions>
						{yes && (
							<Button variant="outlined" onClick={this.handleClickYes}>
								Yes
							</Button>
						)}
						{ok && <Button onClick={this.handleClickOk}>Ok</Button>}
						{no && (
							<Button variant="contained" onClick={this.handleClickNo}>
								No
							</Button>
						)}
						{cancel && <Button onClick={this.handleClickCancel}>Cancel</Button>}
					</DialogActions>
				</DialogContent>
			</Dialog>
		);
	}
}

export default ConfirmDialog;
